var map = {
	"./assortment-category.svg": "45f2",
	"./assortment-info.svg": "6327",
	"./branches.svg": "1f6b",
	"./downloads.svg": "2008",
	"./header-small.svg": "3fa1",
	"./hub.svg": "bc93",
	"./quote.svg": "1636",
	"./text-cta.svg": "5282",
	"./text-image-block.svg": "9fa7",
	"./text-image-news.svg": "d2c6",
	"./text-image.svg": "96c1",
	"./text-news.svg": "8b46",
	"./text-over-image.svg": "fa9e",
	"./text.svg": "d36f",
	"./tiles.svg": "2f31",
	"./usp.svg": "3efb",
	"./widget.svg": "0a8a",
	"./youtube.svg": "11ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";